import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import R from 'ramda'
import moment from 'moment'
import ActivityActions, { ActivityRedux, ActivityTypes } from '../Redux/ActivityRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import { notificationFail, notificationSuccess } from '../Redux/NotificationActions'

const activityCRUDObservable = createCRUDObservable({
  mainRedux: ActivityRedux,
  reduxPath: 'activity',
})

const postActivityEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.postActivityRequest)
    .mergeMap(({ checkinId, data }) => (
      Api.activity.postActivity(checkinId, data)
        .then(response => response.data.data)
        .catch(error => error)
    ))
    .mergeMap((response) => {
      if (response.error) {
        return [
          ActivityActions.postActivityFailure(response.error),
          notificationFail(response.error),
        ]
      }

      let notification = 'Actividad Iniciada'

      if (response.finished_at) {
        notification = 'Actividad Completada'
      }

      return [
        ActivityActions.postActivitySuccess(response),
        ClassroomActions.updateChildActivity(response),
        notificationSuccess(notification),
      ]
    })
)
const getPhotoCatalogueEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.getPhotoCatalogueRequest)
    .mergeMap(() => (
      Api.activity.getPhotoCatalogue()
        .then(response => response.data)
        .catch(error => error)
    ))
    .mergeMap((response) => {
      if (response.error) {
        return [
          ActivityActions.getPhotoCatalogueFailure(response.error),
        ]
      }
      return [
        ActivityActions.getPhotoCatalogueSuccess(response),
      ]
    })
)
const editCheckoutEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.editCheckoutRequest)
    .mergeMap(({ checkout_id,checkout_time }) => (
      Api.activity.editCheckout(checkout_id,checkout_time)
        .then(response => response)
        .catch(error => error)
    ))
    .mergeMap((response) => {
      if (response.error) {
        return [
          ActivityActions.editCheckoutFailure(response.error),
          notificationFail(response.error),
        ]
      }
      let activeStudent = R.clone(store.getState().classrooms.activeStudentId)
      let activeClassroom = R.clone(store.getState().classrooms.activeClassroomId)
      return [
        ActivityActions.editCheckoutSuccess(),
        ClassroomActions.getStudentProfileRequest(activeStudent, activeClassroom,''),
        // ClassroomActions.updateChildActivity(response),
        notificationSuccess("Checkout Editado"),
      ]
    })
)

const postFinishActivityEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.postFinishActivityRequest)
    .mergeMap(({ activityId, data }) => (
      Api.activity.postFinishActivity(activityId, data)
        .then(response => response.data.data)
        .catch(error => error)
    ))
    .mergeMap((response) => {
      if (response.error) {
        const { error } = response

        return [
          ActivityActions.postFinishActivityFailure(error),
          notificationFail(error),
        ]
      }

      const finishedActivity = response
      const state = store.getState()
      let validDate = null
      const allClassrooms = R.clone(state.classrooms.get.results)
      const activeClassroomIndex = R.findIndex(R.propEq('id', state.classrooms.activeClassroomId))(allClassrooms)
      const activeClassroom = allClassrooms[activeClassroomIndex]
      const [student] = activeClassroom.students
        .filter(child => child.checkin.id === finishedActivity.checkin_id)
      const latestActivities = student.latest_activities

      if (latestActivities) {
        Object.keys(latestActivities).map((value) => {
          if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            validDate = value
          }

          return null
        })

        if (validDate) {
          latestActivities[validDate].unshift(finishedActivity)
          const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(activeClassroom.students)
          activeClassroom.students[activeStudentIndex] = student
        } else {
          const [latestActivity] = latestActivities
            .filter(activity => activity.id === finishedActivity.id)
          const latestActivityIndex = R.findIndex(R.propEq('id', latestActivity.id))(latestActivities)

          latestActivities[latestActivityIndex] = finishedActivity
          const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(activeClassroom.students)

          activeClassroom.students[activeStudentIndex] = student
        }
      }

      return [
        ActivityActions.postFinishActivitySuccess(),
        ClassroomActions.updateChildAfterFinishActivity(allClassrooms),
        notificationSuccess('Actividad Finalizada'),
      ]
    })
)

const deleteActivityEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.deleteActivityRequest)
    .mergeMap(({ activityId }) => (
      Observable
        .fromPromise(Api.activity.deleteActivity(activityId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          if (response.status !== 204) {
            return [ActivityActions.deleteActivityError(response.error)]
          }
          return [
            ActivityActions.deleteActivitySuccess(activityId),
            notificationSuccess('Actividad Eliminada'),
            ClassroomActions.deleteActivity(activityId),
          ]
        })
    ))
)

const postGroupActivityEpic = (action$, store, { Api }) => (
  action$.ofType(ActivityTypes.postGroupActivityRequest)
    .mergeMap(({ data }) => (
      Api.activity.postGroupActivity(data)
        .then(response => response.data.data)
        .catch(err => ActivityActions.postGroupActivityFailure(err))
    ))
    .mergeMap(result => {
      if (result.type === 'ACTIVITY_POST_GROUP_ACTIVITY_FAILURE') {
        return ([
          ActivityActions.postGroupActivityFailure(result.errors),
          {
            type: 'NOTIFICATIONS_FIRE_NOTIFICATION',
            mode: 'error',
            title: result.errors.error,
            subtitle: '',
          },
        ])
      } else {
      if (result[0].finished_at === null ) {
        return ([
          ActivityActions.postGroupActivitySuccess(result),
          {
            type: 'NOTIFICATIONS_FIRE_NOTIFICATION',
            mode: 'success',
            title: `Actividad Iniciada`,
            subtitle: '',
          },
          ClassroomActions.updateChildGroupActivity(result),
        ])
      } else {
        return ([
          ActivityActions.postGroupActivitySuccess(result),
          {
            type: 'NOTIFICATIONS_FIRE_NOTIFICATION',
            mode: 'success',
            title: `Actividad Completada`,
            subtitle: '',
          },
          ClassroomActions.updateChildGroupActivity(result),
        ])
      }
    }
  }
    )
)
const activityExcelEpic = (action$, store, { Api }) =>
  action$.ofType(ActivityTypes.activityExcelRequest)
    .mergeMap(({ start_date, end_date,student_id }) => (
      Observable
        .fromPromise(Api.activity.getActivityExcel(start_date, end_date,student_id)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ActivityActions.activityExcelError(response.error),
              notificationFail('Falló la descarga')
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            ActivityActions.activityExcelSuccess(data, fileName),
          ]
        })
    ))

export const activityObservable = Object.assign({}, activityCRUDObservable.observers, {})


export const activityEpic = combineEpics(
  activityCRUDObservable.epic,
  postActivityEpic,
  postGroupActivityEpic,
  postFinishActivityEpic,
  deleteActivityEpic,
  activityExcelEpic,
  editCheckoutEpic,
  getPhotoCatalogueEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ActivityObservable.js